module.exports = "a{\n\tcursor: pointer !important;\n}\n\n.autocomplete {\n    max-height: 200px;\n\toverflow: auto;\n\tmargin: 0 !important;\n\tmax-width: 100% !important;\n    position: absolute !important;\n    width: 100% !important;\n    padding: 0 !important;\n    z-index: 1000;\n}\n\n.autocomplete.apt{\n\ttop: -6px;\n}\n\n.apt_unit_class{\n\tposition: relative;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/service-availability/tdu-details-page/tdu-details-page.component.css
// module id = ./src/app/service-availability/tdu-details-page/tdu-details-page.component.css
// module chunks = main